import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Button,
  Modal,
  Tooltip,
  List,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  DownloadOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import dayjs from "dayjs";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import styles from "../../../../../assets/styles/styles";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const SavingsAccChargeForm = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    chargesOptions,
    userData,
    isLoading,
    setIsLoading,
    chargeTableSource,
    setChargeTableSource,
  } = props;
  const { session } = userData;
  // const [useForm] = Form.useForm();
  const { Text, Title } = Typography;

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargeList, setChargeList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCharge, setEditingCharge] = useState(null);
  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleChargeEdit = (record) => {
    setEditingCharge(record);
    setIsModalOpen(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Collected On",
      dataIndex: "collectedOn",
    },
    {
      title: "Date",
      dataIndex: "feeOnMonthDay",
    },
    {
      title: "Repayments Every",
      dataIndex: "feeInterval",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        chargeTableSource.length >= 1 ? (
          <>
            <Tooltip title="Edit Charge">
              <Button
                type="primary"
                icon={<EditOutlined />}
                shape="round"
                size="small"
                onClick={() => handleChargeEdit(record)}
                style={{ marginRight: 8 }}
                className="of-primaryBtnColor"
              />
            </Tooltip>

            <Tooltip title={`Remove Charge`}>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => handleChargeDelete(record)}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          </>
        ) : null,
    },
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.chargeInfo}
        </Title>
      </Divider>
      <ChargeModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsModalOpen={setIsModalOpen}
        chargeData={chargesOptions}
        setChargeList={setChargeList}
        setChargeTableSource={setChargeTableSource}
        chargeTableSource={chargeTableSource}
        chargeList={chargeList}
        session={session}
        editingCharge={editingCharge}
        setEditingCharge={setEditingCharge}
      />

      {chargeTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {chargeTableSource.length > 1
                ? labelConfig.selectedCharges
                : labelConfig.selectedCharge}
            </Title>
          </Divider>
          <Table
            columns={columns}
            dataSource={chargeTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}
    </Form>
  );
};
export default SavingsAccChargeForm;

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    isModalOpen,
    chargeData,
    setIsModalOpen,
    setChargeList,
    chargeList,
    editingCharge,
    setEditingCharge,
  } = props;

  const [useForm] = Form.useForm();

  // ✅ Modal open & close handlers
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => {
    setIsModalOpen(false);
    setEditingCharge(null);
  };

  // ✅ Disable past dates
  const disablePastDates = (current) => current && current < dayjs().startOf("day");

  // ✅ Save or Update charge
  const handleChargeSave = (formValues) => {
    const rawDate = formValues.feeOnMonthDay
      ? dayjs(formValues.feeOnMonthDay)
      : null;

    const formattedDate = rawDate
      ? rawDate.format("DD MMM YYYY")
      : "-";

    const newCharge = {
      key: formValues?.chargeId,
      id: formValues?.chargeId,
      name: formValues.name,
      type: formValues.type,
      collectedOn: formValues.collectedOn,
      amountToUse: formValues?.amount,
      amount: (
        <Statistic
          value={formValues?.amount}
          precision={2}
          valueStyle={{ fontSize: "16px" }}
        />
      ),
      feeOnMonthDay: formattedDate,
      feeOnMonthDayRaw: rawDate,
      feeInterval: formValues.feeInterval ? formValues.feeInterval : "-",
    };

    let updatedList;

    if (editingCharge) {
      // ✅ Update existing charge
      updatedList = chargeTableSource.map((item) =>
        item.id === editingCharge.id ? newCharge : item
      );
    } else {
      // ✅ Prevent duplicates on new add
      const foundCharge = chargeTableSource.find(
        (item) => item.id === newCharge.id
      );
      if (foundCharge) {
        BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
        return;
      }
      updatedList = [...chargeTableSource, newCharge];
    }

    setChargeTableSource(updatedList);
    setEditingCharge(null);
    useForm.resetFields();
    setIsModalOpen(false);
  };

  // ✅ Fetch charge details on select
  const handleSelectedCharge = (chargeId) => {
    const params = { template: "true" };
    const url = `${apiConfig.charges}/${chargeId}`;
    const body = { session, params };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          key: objList.id,
          id: objList.id,
          name: objList.name,
          type: objList.chargeCalculationType.value,
          collectedOn: objList?.chargeTimeType.value,
          amount: objList?.amount,
          feeOnMonthDay: objList?.feeOnMonthDay
            ? dayjs(BOM.FormatArrayDateWithoutYear(objList?.feeOnMonthDay))
            : null,
          feeInterval: objList?.feeInterval,
        });
      }
      setIsLoading(false);
    });
  };

  // ✅ Populate form on edit
  useEffect(() => {
    if (editingCharge && isModalOpen) {
      useForm.setFieldsValue({
        chargeId: editingCharge.id,
        name: editingCharge.name,
        type: editingCharge.type,
        collectedOn: editingCharge.collectedOn,
        amount:
          editingCharge.amountToUse ||
          editingCharge.amount?.props?.value ||
          "",
        feeOnMonthDay: editingCharge.feeOnMonthDayRaw
          ? dayjs(editingCharge.feeOnMonthDayRaw)
          : editingCharge.feeOnMonthDay && editingCharge.feeOnMonthDay !== "-"
          ? dayjs(editingCharge.feeOnMonthDay, "DD MMM YYYY")
          : null,
        feeInterval:
          editingCharge.feeInterval && editingCharge.feeInterval !== "-"
            ? editingCharge.feeInterval
            : "",
      });
    } else {
      useForm.resetFields();
    }
  }, [editingCharge, isModalOpen]);

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#15CCAE",
          marginBottom: 20,
        }}
      >
        {labelConfig.addCharge}
      </Button>

      <Modal
        open={isModalOpen}
        title={
          editingCharge
            ? "Edit Charge Information"
            : "Charge Information Setup"
        }
        okText={editingCharge ? "Save Changes" : "Add"}
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleChargeSave}
            name="charge-form"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="chargeId"
                label="Charge Options"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.charge),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.charge,
                    "select"
                  )}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Divider />
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.name} name="name">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.type} name="type">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.collectedOn} name="collectedOn">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.collectedOn
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.amount} name="amount">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.date} name="feeOnMonthDay">
                <DatePicker
                  disabledDate={disablePastDates}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.date,
                    "select"
                  )}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.repaymentFrequency}
                name="feeInterval"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.repaymentFrequency
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
